import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import RootLayout from "./pages/dashboard/RootLayout/RootLayout";
import AuthContextProvider from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import AllSongs from "./pages/dashboard/AllSongs/AllSongs";
import AddSong from "./pages/dashboard/AddSong/AddSong";
import EditLyric from "./pages/dashboard/EditLyric/EditLyric";
import "./App.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    ),
  },
  {
    
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <RootLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true, // 👈 matches exactly /dashboard
        element: <h2 className="text-center">Welcome to the Dashboard!</h2>,
      },
      {
        path: "all-songs",
        element: <AllSongs />,
      },
      {
        path: "add-new-song",
        element: <AddSong />
      },
      {
        path: "edit-lyrics",
        element: <EditLyric />
      }
    ],
  },
]);

function App() {
  return (
    <AuthContextProvider>
      <RouterProvider router={router}></RouterProvider>
    </AuthContextProvider>
  );
}

export default App;
